var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "material-input",
    {
      staticClass: "form-group-material-no-label",
      class: _vm.getContainerClass(),
      attrs: {
        label: _vm.label || _vm.labelValue,
        "label-for": _vm.labelValue,
        placeholder: _vm.placeholder,
        "show-tooltip-message": _vm.showTooltipMessage,
        "hidden-label": "",
      },
    },
    [
      _c(_vm.inputComponent, {
        ref: "input",
        tag: "component",
        staticClass: "form material-input form-control",
        class: _vm.componentClass,
        attrs: {
          id: _vm.labelValue,
          type: _vm.type,
          name: _vm.name,
          placeholder: _vm.placeholder,
          value: _vm.localValue,
          disabled: _vm.disabled || _vm.calculatedCondition,
          tabindex: _vm.tabindex,
          calculated: _vm.calculatedCondition,
          loading: _vm.loading,
          "auto-calculated": _vm.autoCalculated,
          decimals: _vm.decimals,
          extension: _vm.isPhoneWithExtension,
          percentage: _vm.percentage,
          "max-length": _vm.maxLength,
          "formatted-decimals": _vm.formattedDecimals,
          max: _vm.max,
          "auto-fill": _vm.autoFill,
          "auto-complete": _vm.autoComplete,
          pattern: _vm.pattern,
          "allow-minus": _vm.allowMinus,
          "allow-plus": _vm.allowPlus,
        },
        on: {
          input: _vm.handleInput,
          change: _vm.handleChange,
          focusout: _vm.handleFocusOut,
        },
      }),
      _vm._v(" "),
      _vm.maxLength && _vm.showMaxLengthLabel
        ? _c(
            "span",
            {
              staticClass: "floating-validation",
              class: {
                "text-danger bold":
                  _vm.localVerificationValueLength > _vm.maxLength,
              },
            },
            [
              _vm._v(
                "\n    (" +
                  _vm._s(_vm.localVerificationValueLength) +
                  "/" +
                  _vm._s(_vm.maxLength) +
                  ")\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("section-error", {
        attrs: { "error-message": _vm.displayErrorMessage },
      }),
      _vm._v(" "),
      _vm.calculator
        ? _c("span", { staticClass: "input-calculator-icon" }, [
            _c(
              "a",
              {
                staticClass: "text-primary ml-2 clickable",
                on: {
                  click: function ($event) {
                    return _vm.calculate()
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fa fa-calculator",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }